module.exports = __webpack_public_path__ + "assets/img/slaitinis-stogas-su-stoglangiu.18c6750a.webp";